import { Box, Typography } from "@mui/material";

function DealTags({ fulfillment, timeOfDay }) {
  const renderFulfillment = () => {
    if (!fulfillment || !Array.isArray(fulfillment) || fulfillment.length === 0)
      return null;

    return fulfillment.map((f, index) => {
      let label;
      let style;

      switch (f) {
        case "dine_in":
          label = "Dine-in";
          style = { bg: "#e0f2f1", fg: "#00796b" };
          break;
        case "self_pickup":
          label = "Pickup";
          style = { bg: "#e8f5e9", fg: "#2e7d32" };
          break;
        case "delivery":
          label = "Delivery";
          style = { bg: "#fff3e0", fg: "#e65100" };
          break;
        default:
          label = f;
          style = { bg: "#f4f4f4", fg: "#000" };
      }

      return (
        <Box
          key={index}
          sx={{ bgcolor: style.bg, borderRadius: "6px", px: 1, py: 0.4 }}
        >
          <Typography
            variant="body2"
            sx={{ fontWeight: 500, color: style.fg, fontSize: "12px" }}
          >
            {label}
          </Typography>
        </Box>
      );
    });
  };

  const renderTimeOfDay = () => {
    if (!timeOfDay || !Array.isArray(timeOfDay) || timeOfDay.length === 0)
      return null;

    const timeLabels = timeOfDay.map((t) => {
      switch (t) {
        case "breakfast":
          return "Breakfast";
        case "lunch":
          return "Lunch";
        case "dinner":
          return "Dinner";
        case "all_day":
          return "All-Day";
        default:
          return t;
      }
    });

    const label = timeLabels.join(" · ");
    const style = { bg: "#fff8e1", fg: "#f57c00" };

    return (
      <Box sx={{ bgcolor: style.bg, borderRadius: "6px", px: 1, py: 0.4 }}>
        <Typography
          variant="body2"
          sx={{ fontWeight: 500, color: style.fg, fontSize: "12px" }}
        >
          {label}
        </Typography>
      </Box>
    );
  };

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 0.25 }}>
      {renderFulfillment()}
      {renderTimeOfDay()}
    </Box>
  );
}

export default DealTags;
